import { FC, ReactElement, useState } from 'react'
import chevron from '../../assets/icons/chevron.svg'
import { Container } from './styles'

type FrameProps = {
  title: string
  content: string
  defaultIsOpen?: boolean
}

const FaqQuestion: FC<FrameProps> = ({ title, content, defaultIsOpen = false }): ReactElement => {
  const [isOpen, setIsOpen] = useState(defaultIsOpen)
  return (
    <Container>
      <div className={`faq_content${isOpen ? ' open' : ' closed'}`}>
        <h3 onClick={() => setIsOpen(d => !d)} className='faq_content__title'>{title}</h3>
        <p className='faq_content__response' dangerouslySetInnerHTML={{ __html: content }} />
      </div>
      <button
        onClick={() => setIsOpen(d => !d)}
        type='button'
        className={isOpen ? 'open' : 'closed'}
      >
        <img src={chevron} alt='chevron' />
      </button>
    </Container>
  )
}

export default FaqQuestion
